// extracted by mini-css-extract-plugin
export default {"csFaqItem":"FaqItem_csFaqItem__eCHmo","faqTitle":"FaqItem_faqTitle__0rSOG","faqAnswerOpen":"FaqItem_faqAnswerOpen__B1TaJ","faqAnswer":"FaqItem_faqAnswer__WlafX"};